







































import { Vue, Component, Prop } from "vue-property-decorator";
import { IGoogleFont } from "@/models/google";

@Component
export default class FontGridItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public font?: IGoogleFont;

  @Prop({ default: 2.5 })
  public size!: number;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public text!: string;

  @Prop({ default: null })
  public ctaLabel!: string;

  @Prop({ default: false })
  public canDelete!: boolean;

  @Prop({ default: "font" })
  public dataAttrName!: string;

  // Data

  public link: Element | null = null;

  // Life-cycle methods

  public mounted() {
    this.appendLink();
  }

  public beforeDestroy() {
    if (this.link) this.link.remove();
  }

  // Computed

  public get style() {
    return {
      fontFamily: this.font?.family,
      fontSize: `${this.size}rem`
    };
  }

  // Methods

  public appendLink() {
    if (!this.font) return;
    this.link = document.querySelector(
      `link[data-${this.dataAttrName}="${this.font.family}"]`
    );
    if (this.link) return;
    this.link = document.createElement("link");
    this.link.setAttribute("rel", "stylesheet");
    this.link.setAttribute(`data-${this.dataAttrName}`, this.font?.family);
    this.link.setAttribute(
      "href",
      `https://fonts.googleapis.com/css?family=${this.font.family}`
    );
    document.head.appendChild(this.link);
  }

  public redirectToGoogleFont() {
    window.open(
      `https://fonts.google.com/specimen/${this.font?.family?.replace(
        /\s/g,
        "+"
      )}`,
      "_blank"
    );
  }
}
